// extracted by mini-css-extract-plugin
export default {"swatch":"Swatches_swatch__lQPta","swatch___active":"Swatches_swatch___active__vT4nf"};